var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.countTimeStr)?_c('div',{staticClass:"groupCountDown"},[_vm._v("\n  "+_vm._s(_vm.countTimeStr)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }